<template>
  <div>
    <app-base-main
        parentTable
        table-border-top
        style="padding: 12px 0 0;">
      <template #filter-group>
        <app-filter-group
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <gj-search-input
              v-model="filter.transportName"
              width="200px"
              placeholder="物流方式"
          ></gj-search-input>
          <gj-country-select
              v-model="filter.shippedCountryCode"
              includeCN
              placeholder="发货国家">
          </gj-country-select>
          <gj-country-select
              v-model="filter.arrivalCountryCode"
              includeCN
              placeholder="目的国家">
          </gj-country-select>
          <template #right>
            <gj-tool-group
                help
            ></gj-tool-group>
          </template>
        </app-filter-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            name="headLogisticsDuration"
            adapt-parent
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :pagination="pagination"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
        </gj-table>
      </template>
    </app-base-main>
  </div>
</template>

<script>
  import {queryMixin, selectionMixin} from "@/minxins";
  import {defaultVal} from "@/utils/common";
  import {getLogisticsTransportPrescriptionPage} from "@/api/logistics";
  import {mapGetters} from "vuex";

  export default {
    name: "app-head-logistics-duration",
    mixins: [queryMixin, selectionMixin],
    computed: {
      ...mapGetters(['userGuideState'])
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'transportName', header: '物流方式', field: 'transportName', minWidth: '100px'},
          {id: 'shippedCountryCode', header: '发货国家', field: 'shippedCountryCode', minWidth: '100px'},
          {id: 'arrivalCountryCode', header: '目的国家', field: 'arrivalCountryCode', minWidth: '100px'},
          {id: 'prescription', header: '时效(天)', field: 'prescription', width: '200px', align: 'right'},
          {id: 'memo', header: '备注', field: 'memo', minWidth: '200px', overflowLine: 2},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', width: '200px'},
        ],
        filter: {
          name: null,
          status: null
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-head-logistics-duration',
        notStorage: true
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            transportName: null,
            shippedCountryCode: null,
            arrivalCountryCode: null
          }
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            transportName: this.filter.transportName,
            shippedCountryCode: defaultVal(this.filter.shippedCountryCode),
            arrivalCountryCode: defaultVal(this.filter.arrivalCountryCode),
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getLogisticsTransportPrescriptionPage(params)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
      }
    }
  }
</script>

<style scoped>

</style>

